import { observer } from "mobx-react-lite";
import { useFormikContext } from "formik";
import { useTran } from "@/hooks";
import { SelectField } from "@/components/common";
import { INDUSTRIAL_CLASSIFICATION } from "@/lib/constants";

const CompanySetupStepTwo = observer(() => {
  const { t } = useTran();
  const { values, touched, errors, setFieldValue, setFieldTouched } =
    useFormikContext();

  const getFieldError = (key) => (touched?.[key] ? errors?.[key] : undefined);

  const handleIndustryChange = (event) => {
    const nextValue = event?.target?.value || "";
    setFieldValue("industry", nextValue, true);
    setFieldTouched("industry", true, false);
  };

  return (
    <div className="space-y-6">
      <SelectField
        id="industry"
        label={t("What is your industry?")}
        required
        placeholder={t("Select industry")}
        value={values.industry}
        options={INDUSTRIAL_CLASSIFICATION}
        onChange={handleIndustryChange}
        error={getFieldError("industry")}
      />
    </div>
  );
});

export default CompanySetupStepTwo;
